const turkishUiLabels = new Map([
  ['Buy it now', 'Şimdi Satın Al'],
  ['Buy now', 'Şimdi Satın Al'],
  ['Add to cart', 'Sepete Ekle'],
  ['Sold out', 'Tükendi'],
  ['Out of stock', 'Stokta Yok'],
  ['Pre-order', 'Ön Sipariş'],
  ['Checkout', 'Güvenli Ödemeye Geç'],
  ['View product', 'Ürünü Gör'],
  ['View all', 'Tümünü Gör']
]);

function localizeShopifyUi(root = document) {
  root.querySelectorAll('button, .shopify-payment-button__button, input[type="submit"]').forEach((element) => {
    const current = (element.tagName === 'INPUT' ? element.value : element.textContent).trim();
    const translated = turkishUiLabels.get(current);
    if (!translated) return;
    if (element.tagName === 'INPUT') element.value = translated;
    else element.textContent = translated;
    element.setAttribute('aria-label', translated);
  });
}

function startTurkishUi() {
  localizeShopifyUi();
  document.documentElement.classList.add('tr-ui-ready');
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      localizeShopifyUi(node.matches?.('button,input') ? node.parentElement : node);
    }));
  }).observe(document.documentElement, {childList: true, subtree: true});
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startTurkishUi);
else startTurkishUi();
